import { MetaInfo, Select as SelectType } from "@/hooks/useSurvey"
import { Autocomplete, AutocompleteItem, Progress } from "@heroui/react"
import { useEffect, useState } from "react"

interface SelectsProps {
    select: MetaInfo
    validaPorToken: boolean | undefined
    index: number
    metaInfo: MetaInfo[]
    handleMetaInfo: (i: number, value: string) => void
    metaInfoDepende?: number | null;
    handleObtenerSelect: (nEncuesta: number, nEncuestaMetaInfo: number, nRespuestaMetaInfoDepende: number | null) => Promise<SelectType[] | undefined>
}

interface SelectTypeResponse {
    id: number,
    label: string
}

export const Selects = ({ select, index, handleMetaInfo, metaInfoDepende = null, handleObtenerSelect, metaInfo }: SelectsProps) => {
    const [values, setValues] = useState<SelectTypeResponse[]>();
    const [value, setValue] = useState<SelectTypeResponse | null>(null);
    const [selectDisabled, setSelectDisabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>();

    const handleGetInformation = async () => {
        setLoading(true);
        const response = await handleObtenerSelect(4, select.nEncuestaMetaInfo, metaInfoDepende);
        if (response) {
            setValues(response.map((item) => ({
                id: item.nRespuesta,
                label: item.cRespuesta,
            })));

            if (select.cValor) {
                const foundValue = response.find((item) => item.nRespuesta.toString() === select.cValor);
                
                if (foundValue) {
                    setValue({
                        id: foundValue.nRespuesta,
                        label: foundValue.cRespuesta,
                    });
                } else {
                    setValue(null);
                }
            }
        }
        setLoading(false);
    };

    const handleChangeSelect = (key: React.Key | null) => {
        if (key === null) {
            handleMetaInfo(index, '');
            setValue(null);
            return;
        }
        const selected = values?.find((item) => item.id.toString() === key.toString());
        if (selected) {
            handleMetaInfo(index, selected.id.toString());
            setValue(selected);
        }
    };

    useEffect(() => {
        handleGetInformation();
    }, []);

    useEffect(() => {
        if (select.nEncuestaMetaInfoDepende) {
            const valor = metaInfo.find((item) => item.nEncuestaMetaInfo === select.nEncuestaMetaInfoDepende)?.cValor ?? null;
            
            if (!valor) {
                handleMetaInfo(index, '');
                setValue(null);
                setSelectDisabled(true);
            } else {
                setSelectDisabled(false);
                handleGetInformation();
            }
        }
    }, [metaInfoDepende]);

    return (
        <div className="m-2">
            {values && !loading ? (
                <Autocomplete
                    label={select.cNombreMetaInfo}
                    variant="underlined"
                    selectedKey={value?.id?.toString() ?? null}
                    isDisabled={selectDisabled}
                    onSelectionChange={handleChangeSelect}
                    className="w-full"
                >
                    {(values ?? []).map((item) => (
                        <AutocompleteItem key={item.id.toString()}>
                            {item.label}
                        </AutocompleteItem>
                    ))}
                </Autocomplete>
            ) : (
                <div>
                    <div className="text-gray-500 mb-1">{select.cNombreMetaInfo}</div>
                    <Progress
                        size="sm"
                        isIndeterminate
                        color="success"
                        aria-label="Cargando..."
                    />
                </div>
            )}
        </div>
    );
};
